export default __webpack_public_path__ + "static/media/touchOne.39cbde70.svg";